import input from './components/UUIInput'
import button from './components/UUIButton'
import textArea from './components/UUITextArea'
import Checkbox from './components/UUICheckbox'
import RadioButton from './components/UUIRadioButton'
import Select from './components/UUISelect'
import MultiSelect from './components/UUIMultiSelect'
import Suggestions from './components/UUISuggestions'
import DatePicker from './components/UUIDatePicker'
import Tooltip from './components/UUITooltip'

export default {
  Input: input,
  Button: button,
  TextArea: textArea,
  Checkbox: Checkbox,
  RadioButton: RadioButton,
  Select: Select,
  MultiSelect: MultiSelect,
  Suggestions: Suggestions,
  DatePicker: DatePicker,
  Tooltip: Tooltip
}
